<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
               <template slot="BodyFormLoad">
                   <div class="container-fluid">
                       <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                        <label class="form-label" for="IdMenu">Menú</label>
                                        <select v-model="objModuloSistema.IdMenu" class="form-select form-control-search">
                                            <option value=0>Seleccionar</option>
                                            <option v-for="(item,index) in PanelesMenu" :key="index" :value="item.IdPanel">{{item.Nombre}}</option>
                                        </select>
                                        <!-- <input type="text" v-model="objModuloSistema.IdMenu" class="form-control" id="IdMenu" placeholder="Ingresar IdMenu" /> -->
                                        <CValidation v-if="this.errorvalidacion.IdMenu" :Mensaje="'*'+errorvalidacion.IdMenu[0]"/>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                        <label class="form-label" for="Nombre">Nombre</label>
                                        <input type="text" v-model="objModuloSistema.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
                                        <CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-4">
                                        <div class="card">
                                            <div class="card-header pb-0">
                                                <h6>Módulos Agregados</h6>
                                            </div>
                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <CLoader :pConfigLoad="ConfigLoadDetallesModulo">
                                                        <template slot="BodyFormLoad">
                                                            <table class="table align-items-center mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th :class="StyleTh+' text-center'">#</th>
                                                                        <th :class="StyleTh" width="80%">Nombre</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(lista,index) in ListaModuloDetalles" :key="index">
                                                                        <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                                        <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                                                    </tr>
                                                                    <CSinRegistros :pContIF="ListaModuloDetalles.length" :pColspan="6"></CSinRegistros>
                                                                </tbody>
                                                            </table>
                                                        </template>
                                                    </CLoader>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8">
                                        <CList @FiltrarC="ListaModulos()" :pConfigList="ConfigListPaneles" :pFiltro="Filtro" :segurity="segurity">
                                            <template slot="Filtros">
                                                <div class="row mt-3">
                                                    <div class="col-auto">
                                                        <label class="col-form-label text-primary">Menú</label>
                                                    </div>
                                                    <div class="col-auto">
                                                        <select @change="GetCmbSubMenu();ListaModulos()" v-model="Filtro.Menu" class="form-select form-control-search">
                                                            <option value="">Todos</option>
                                                            <option v-for="(item,index) in PanelesMenu" :key="index" :value="item.IdPanel">{{item.Nombre}}</option>
                                                        </select>
                                                    </div>
    
                                                    <div v-if="Filtro.Menu" class="col-auto">
                                                        <label class="col-form-label text-primary">Submenú</label>
                                                    </div>
                                                    <div v-if="Filtro.Menu" class="col-auto">
                                                        <select @change="GetCmbApartado();ListaModulos()" v-model="Filtro.SubMenu" class="form-select form-control-search">
                                                            <option value="">Todos</option>
                                                            <option v-for="(item,index) in PanelesSubMenu" :key="index" :value="item.IdPanel">{{item.Nombre}}</option>
                                                        </select>
                                                    </div>
    
                                                    <div v-if="Filtro.SubMenu" class="col-auto">
                                                        <label class="col-form-label text-primary">Apartado</label>
                                                    </div>
                                                    <div v-if="Filtro.SubMenu" class="col-auto">
                                                        <select @change="ListaModulos()" v-model="Filtro.Apartado" class="form-select form-control-search">
                                                            <option value="">Todos</option>
                                                            <option v-for="(item,index) in PanelesApartado" :key="index" :value="item.IdPanel">{{item.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="header">
                                                <th :class="StyleTh+' text-center'">#</th>
                                                <th :class="StyleTh" width="60%">Nombre</th>
                                                <th :class="StyleTh">Agregar</th>
                                            </template>
                                            <template slot="body">
                                                    <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                                                        <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                        <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                                        <td>
                                                            <div class="form-check">
                                                                <input name="Aregado" id="" class="form-check-input"
                                                                    type="checkbox" v-model="lista.Agregado" @change="AgregarModulo(lista)" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="4"></CSinRegistros>
                                            </template>
                                        </CList>
                                    </div>
                                </div>
                            </div>
                       </div>
                   </div>
                   <CBtnSave :poBtnSave="oBtnSave" />
                </template>
            </CLoader>
        </template>
    </CList>
</template>

<script>
const EmitEjecuta = 'FormModuloSitema'
import Configs from '@/helpers/VarConfig.js';
import moment from 'moment';
export default {
    name: 'FormModuloSistema',
    props: ['Id'],
    components:{
    },
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
            ConfigListPaneles:{
                Title:'Módulos',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: true,
                ShowFooter: false,
            },
			ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
			ConfigLoadDetallesModulo:{
                ShowLoader: false,
                ClassLoad: false,
            },
            objModuloSistema: {
				IdModuloSistema: 0,
				IdMenu: 0,
				Nombre: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar...',
                Menu:'',
                SubMenu:'',
                Apartado:'',
                IdAsociado:0,
                TipoMenu:'',
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'modulosSistema',
                EmitSeccion: EmitEjecuta,
				ActiveEmitReturn: true,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],         
            IdModuloSistema:0,
            ListaModuloDetalles: [],
            PanelesMenu: [],
            PanelesSubMenu: [],
            PanelesApartado: [],
            PanelesSubApartado: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            errorvalidacion: [],
			Emit: EmitEjecuta,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
            if (this.ListaModuloDetalles.length <= 0){
                this.$toast.warning('Es necesario agregar módulos.');
                this.oBtnSave.DisableBtn = false;
                return false;
            }

			if(this.objModuloSistema.IdModuloSistema == 0) {
				await this.$http.post(
					'modulosSistema',{...this.objModuloSistema,
                        ListaModuloDetalles:this.ListaModuloDetalles
                    }
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'modulosSistema/'+this.objModuloSistema.IdModuloSistema,
					{...this.objModuloSistema,
                        ListaModuloDetalles:this.ListaModuloDetalles
                    }
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
        async ListaModulos()
        {
            this.ConfigListPaneles.ShowLoader = true;
            let tipoMenu = 'Menu';
            tipoMenu = this.Filtro.Menu ? 'SubMenu':tipoMenu;
            tipoMenu = this.Filtro.SubMenu ? 'Apartado':tipoMenu;
            tipoMenu = this.Filtro.Apartado ? 'SubApartado':tipoMenu;

            let idAsociado = 0;
            idAsociado = this.Filtro.Menu > 0 ? this.Filtro.Menu : 0,
            idAsociado = this.Filtro.SubMenu > 0 ? this.Filtro.SubMenu : idAsociado,
            idAsociado = this.Filtro.Apartado > 0 ? this.Filtro.Apartado : idAsociado,

            await this.$http.get("panelmenu",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    TipoMenu:tipoMenu,
                    IdAsociado:idAsociado,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.ListaArrayRows.forEach(lista => {
                    let inModulosDetalles = this.ListaModuloDetalles.some(elem => lista.IdPanel == elem.IdMenu);
                    lista['Agregado'] = inModulosDetalles;
                })
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigListPaneles.ShowLoader = false;
            });
        },
        AgregarModulo(modulo){
            if (modulo.Agregado) {
                let newDetalleModulo = {
                    IdModuloSistemaDetalle:0,
                    IdModuloSistema:0,
                    IdMenu:modulo.IdPanel,
                    Nombre:modulo.Nombre,
                }
                this.ListaModuloDetalles.push(newDetalleModulo);
            } else {
                let indexEliminado = this.ListaModuloDetalles.findIndex(elem => elem.Nombre === modulo.Nombre)
                this.ListaModuloDetalles.splice(indexEliminado,1)
            }
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "modulosSistema/"+this.objModuloSistema.IdModuloSistema
            ).then((res) => {
                this.objModuloSistema = res.data.data;
                this.ListaModuloDetalles = res.data.Detalles;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        GetCmbMenu(){
            this.$http.get('panelmenu', {params:{
                IdAsociado:0,
                TipoMenu:'Menu',
                simple:1,
            }}).then((res) =>{
                this.PanelesMenu = res.data.data;
            })
        },
        GetCmbSubMenu(){
            this.Filtro.SubMenu = '';
            this.Filtro.Apartado = '';
            this.$http.get('panelmenu', {params:{
                IdAsociado:this.Filtro.Menu,
                TipoMenu:'SubMenu',
                simple:1,
            }}).then((res) =>{
                this.PanelesSubMenu = res.data.data;
            })
        },
        GetCmbApartado(){
            this.Filtro.Apartado = '';
            this.$http.get('panelmenu', {params:{
                IdAsociado:this.Filtro.SubMenu,
                TipoMenu:'Apartado',
                simple:1,
            }}).then((res) =>{
                this.PanelesApartado = res.data.data;
            })
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{}});
        },
        Limpiar()
        {
            this.objModuloSistema = {
				IdModuloSistema: 0,
				IdMenu: 0,
				Nombre: '',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;
        if(this.Id != undefined){
            sessionStorage.setItem('IdModuloSistema',JSON.stringify(this.Id));
        }
        this.IdModuloSistema = JSON.parse(sessionStorage.getItem('IdModuloSistema'));
        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.IdModuloSistema)
        {
            this.objModuloSistema.IdModuloSistema = this.IdModuloSistema;
            this.Recuperar();
        }
        else
        {
            this.ConfigLoad.ShowLoader = false;
        }
        this.GetCmbMenu();
        this.ListaModulos();

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
